import { TSPApplicationPage } from '../components/TSPApplicationPage';

export default function TSPApplyPage() {
  return <TSPApplicationPage />;
}
